import { ErrorDataType } from '@molecules/CheckoutPaymentButton/CheckoutPaymentButton';
import { PlaceOrderErrorResponse } from '@enums/PlaceOrderErrorResponse';

const getCheckoutPaymentErrorMessage = (errorData: ErrorDataType) => {
  let errorCode;
  switch (errorData.errorCode) {
    case PlaceOrderErrorResponse.INVOICE_BLOCKED:
      errorCode = 'invoiceBlocked';
      break;
    case PlaceOrderErrorResponse.ORDER_LIMIT:
      errorCode = 'orderLimit';
      break;
    case PlaceOrderErrorResponse.WRONG_STORE:
      errorCode = 'wrongStore';
      break;
    case PlaceOrderErrorResponse.NO_DELIVERY_SLOT:
      errorCode = 'noDeliverySlot';
      break;
    default:
      errorCode = 'default';
      break;
  }
  return { ...errorData, title: `error->${errorCode}->title`, text: `error->${errorCode}->text`, show: true };
};

export default getCheckoutPaymentErrorMessage;
